import {Component, OnInit} from '@angular/core';
import {Company, Token, UserDetails, UserSignInInfo} from '../app.model';
import {AppService} from '../app.service';
import {CacheService} from '../cache.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {CommonDialogComponent} from '../common-dialog/common-dialog.component';
import {environment} from '../../environments/environment';
import {NgForm} from '@angular/forms';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import { oldPricingRoute } from '../shared/namespaces';
import { trackFreshsalesEvent } from '../shared/helpers';


// import {MixpanelService} from '../services/mixpanel.service';

@Component({
  selector: 'app-login-register',
  templateUrl: './login-register.component.html',
  styleUrls: ['./login-register.component.scss']
})
export class LoginRegisterComponent implements OnInit {

  userData: any;
  companies: Company[] = [];
  userSignUpInfo = new UserDetails();
  userSignInInfo: UserSignInInfo = new UserSignInInfo();
  verifyPassword: string;
  agreeTUP: boolean;
  rememberMe: boolean;
  showForgotPassword: boolean;
  userForgotPassword: UserSignInInfo = new UserSignInInfo();
  form: HTMLFormElement;
  buttonText = 'SIGN UP';
  showLoginBlock = true;
  userId = 0;
  baseWord: string = this.appService.getBaseWord();
  uncommonBaseWord: string = this.appService.getUncommonBaseWord();
  signedUp = false;
  private appUrl = environment.apiUrl;

  constructor(private appService: AppService, private cacheService: CacheService,
              private router: Router, private dialog: MatDialog, private route: ActivatedRoute,
              private afAuth: AngularFireAuth // Inject Firebase auth service
              //  private mixpanel: MixpanelService
  ) {
    this.afAuth.authState.subscribe(user => {
      if (user) {
        this.userData = user;
      }
    });

  }

  ngOnInit() {
    const saras_auth_key = this.cacheService.getObject<Token>('saras_auth_key');
    if (saras_auth_key) {
      this.userId = saras_auth_key.userId;
    }
    if (this.userId) {
      this.router.navigate(['/' + this.baseWord + '/datasources-listing']);
    }
    const emailQueryParam = this.route.snapshot.queryParamMap.get('email');
    if (emailQueryParam && !this.signedUp) {
      this.toggleSignIn();
      this.userSignUpInfo.email = emailQueryParam;
    } else if (emailQueryParam && this.signedUp) {
      this.userSignInInfo.email = emailQueryParam;
    }
  }

  toggleSignIn() {
    this.buttonText = (this.buttonText === 'SIGN UP') ? 'SIGN IN' : 'SIGN UP';
    this.showLoginBlock = !this.showLoginBlock;
  }

  signIn() {
    this.afAuth.signInWithEmailAndPassword(this.userSignInInfo.email, this.userSignInInfo.password)
      .then((result) => {
        this.userData = result.user;
        return result.user.getIdTokenResult();
      })
      .then((idTokenResult) => {
        if (this.userData.emailVerified) {
          this.appService.verifyFirebaseToken(idTokenResult.token).then((saras_token) => {
            const token = new Token();
            token.role = saras_token.role;
            token.token = saras_token.token;
            token.userId = saras_token.userId;
            this.cacheService.putObject('saras_auth_key', token, true);
            if (environment.apiUrl === 'https://webapi.sarasanalytics.com/') {
           
              window['dataLayer'].push({'event': 'Sign-in', 'eventCategory': 'Sign-in', 'eventAction': 'Success'});

            }
            // this.closeModal();
            this.appService.getUserLoginEvent().next(true);
            this.routeBackFromLogin();
            this.routeToTopics();
          });
        } else {
          const err = {};
          err['statusText'] = 'user is not verified';
          this.appService.openErrorDialog(err, false, 'Authentication error');
        }

      })
      .catch((error) => {
        if (error.code === 'auth/user-not-found') {
          const err = {};
          err['statusText'] = error.message;
          this.appService.openErrorDialog(err, false, 'Authentication error');
        } else if (error.code === 'auth/wrong-password') {
          const err = {};
          err['statusText'] = error.message;
          this.appService.openErrorDialog(err, false, 'Authentication error');
        }
        this.appService.getUserLoginEvent().next(false);
        this.clearData();
      });


    // this.appService.signIn(this.userSignInInfo.email, this.userSignInInfo.password, 'login').then((token) => {
    //   this.cacheService.putObject('saras_auth_key', token, true);
    //   if (environment.mixpanelProjectToken) {
    //     mixpanel.register({
    //       'email': this.userSignInInfo.email,
    //       'userId': token.userId,
    //       'role': token.role
    //     });
    //     mixpanel.track(
    //       'login success'
    //     );
    //   }
    //   // this.closeModal();
    //   this.appService.getUserLoginEvent().next(true);
    //   // this.routeBackFromLogin();
    //   this.routeToTopics();
    // }, () => {
    //   this.appService.getUserLoginEvent().next(false);
    //   this.clearData();
    // });
  }


  submitForgotPassword() {
    /* this.afAuth.auth.sendPasswordResetEmail(this.userForgotPassword.email).then(()=>{
          const dialogRef = this.dialog.open(CommonDialogComponent, {
            data: {
              title: 'Recover Password',
              content: 'A verification link has been sent',
              image: '../../assets/images/tickmark.jpg',
              buttons: [
                {
                  'title': 'OK',
                  'meta': '/' + this.uncommonBaseWord + '/login',
                  'type': 'no-change',
                  'class': 'confirm-dialog-later'
                }
              ]
            },
            disableClose: true
          });

          this.showForgotPassword = false;

        });
    */
    this.appService.forgotPassword(this.userForgotPassword).then(() => {
      // this.openSuccessDailog('Alert!', 'A verification link has been sent');
      // require change add email in content
      const dialogRef = this.dialog.open(CommonDialogComponent, {
        data: {
          title: 'Recover Password',
          content: 'A verification link has been sent',
          image: 'successful',
          buttons: [
            {
              'title': 'OK',
              'meta': '/' + this.uncommonBaseWord + '/login',
              'type': 'no-change',
              'class': 'confirm-dialog-later'
            }
          ]
        },
        disableClose: true
      });

      this.showForgotPassword = false;
      // this.dialogRef.close();
    });

  }

  /*sendVerifcation() {
    this.userData.sendEmailVerification();
    return auth.currentUser.sendEmailVerification()
      .then(() => {
        this.router.navigate(['verify-email-address']);
      });
  }*/

  signUp(form: NgForm) {
    /*  this.appService.getCompanies().then((companies)=>{
        let  companiesArr =[]
        companies.forEach(function (company) {
           companiesArr.push(company.name)
         });
        if(companiesArr.includes(this.userSignUpInfo.company.name)){
          var err=  {}
          err['statusText'] =' company '+this.userSignUpInfo.company.name+' is already exit';
          this.appService.openErrorDialog(err, false, {});
          this.appService.handleError(err,false);
        }else{
          this.afAuth.auth.createUserWithEmailAndPassword(this.userSignUpInfo.email, this.userSignUpInfo.password)
            .then((result) => {
              let  uid =this.afAuth.auth.currentUser.uid;
              this.sendVerifcation();
              this.userSignUpInfo.uid = this.afAuth.auth.currentUser.uid;
              this.appService.signUp(this.userSignUpInfo).then((repsone) => {
                if (environment.mixpanelProjectToken) {
                  const mixpanelData = {
                    'email': this.userSignUpInfo.email
                  };
                  mixpanel.track('signup success', mixpanelData);
                }
                // this.openSuccessDailog('Alert!', '');
                const dialogRef = this.dialog.open(CommonDialogComponent, {
                  data: {
                    title: 'Signup Successful',
                    content: 'Activate your account by clicking on the verification link sent to your email',
                    image: '../../assets/images/tickmark.jpg',
                    buttons: [
                      {
                        'title': 'OK',
                        'meta': '/' + this.uncommonBaseWord + '/login',
                        'type': 'redirect',
                        'class': 'confirm-dialog-later'
                      }
                    ]
                  },
                  disableClose: true
                });
                this.showLoginBlock = !this.showLoginBlock;
                this.buttonText = (this.buttonText === 'SIGN UP') ? 'SIGN IN' : 'SIGN UP';
                this.signedUp = true;
                form.resetForm();
              });


            }).catch((error) => {
            var err=  {}
            err['statusText'] = error.message
            this.appService.handleError(err,false);
          })
        }
      });
  */


    this.appService.signUp(this.userSignUpInfo).then((repsone) => {

      if(environment.apiUrl === 'https://webapi.sarasanalytics.com/') {

        window['dataLayer'].push({'event': 'Sign-up', 'eventCategory': 'Sign-Up', 'eventAction': 'Success'});
        trackFreshsalesEvent('signup');

      }

      


      // this.openSuccessDailog('Alert!', '');
      const dialogRef = this.dialog.open(CommonDialogComponent, {
        data: {
          title: 'Signup Successful',
          content: 'Activate your account by clicking on the verification link sent to your email',
          image: 'successful',
          buttons: [
            {
              'title': 'OK',
              'meta': '/' + this.uncommonBaseWord + '/login',
              'type': 'redirect',
              'class': 'confirm-dialog-later'
            }
          ]
        },
        disableClose: true
      });
      this.showLoginBlock = !this.showLoginBlock;
      this.buttonText = (this.buttonText === 'SIGN UP') ? 'SIGN IN' : 'SIGN UP';
      this.signedUp = true;
      form.resetForm();

    });
  }

  clearData() {
    this.userSignInInfo = new UserSignInInfo();
    this.userSignUpInfo = new UserDetails();
    this.showForgotPassword = false;
  }

  forgotPassword() {
    this.showForgotPassword = true;

  }

  goBackToSignIn() {
    this.showForgotPassword = false;
  }

  routeToTopics() {
    const saras_auth_key = this.cacheService.getObject<Token>('saras_auth_key');
    if (saras_auth_key) {
      this.userId = saras_auth_key.userId;
      this.appService.getCurrentSubscriptionPlan(this.userId).then((response) => {
        const body = response.body;
        if (body.userSubscriptionId === 0) {
          this.disableComponents();
          const freeTrialQueryParam = this.route.snapshot.queryParamMap.get('free_trial');
          if (freeTrialQueryParam === '1') {
            this.routeToPricing(true);
          } else {
            //this.routeToPricing();
            this.router.navigate(['/' + this.baseWord + '/datasources-listing']);
          }
        } else {

          this.appService.getTrialPlan(this.userId).then(trialPlan => {
            if (body.subscriptionPlanId === trialPlan.plan.subscriptionPlanId && trialPlan.expireIn === 0) {
              this.routeToPricing();
            } else {
              this.router.navigate(['/' + this.baseWord + '/integrations-list']);
            }
          });

          // this.appService.getSourceCount(this.userId).then((count) => {
          //   if (count > 0) {
          //     this.routeToDashboard();
          //   } else {
          //     this.routeToIntegrations();
          //   }
          // });
        }
      });
    }
  }

  disableComponents() {
    this.cacheService.putObject('disableDashboard', true, false);
    this.cacheService.putObject('disableDasource', true, false);
    this.cacheService.putObject('disableIntegrations', true, false);
    this.cacheService.putObject('disablePricing', false, false);

  }

  routeBackFromLogin() {
    let routeBack = this.route.snapshot.queryParamMap.get('routeTo');
    if (routeBack === null) {
      routeBack = '/';
    }
    this.router.navigate([routeBack]);
  }

  routeToDashboard() {
    let routeBack = this.route.snapshot.queryParamMap.get('routeTo');
    if (routeBack === null) {
      routeBack = '/' + this.baseWord + '/dashboard';
    }
    this.router.navigate([routeBack]);
  }

  routeToIntegrations() {
    let routeBack = this.route.snapshot.queryParamMap.get('routeTo');
    if (routeBack === null) {
      routeBack = '/' + this.baseWord + '/integrations-list';
    }
    this.router.navigate([routeBack]);
  }

  routeToPricing(free_trial = false) {
    let routeBack = this.route.snapshot.queryParamMap.get('routeTo');
    if (routeBack === null) {
      if (free_trial) {
        
        routeBack = oldPricingRoute;
        this.router.navigate([routeBack], {queryParams: {free_trial: '1'}});
      } else {
        routeBack = oldPricingRoute;
        this.router.navigate([routeBack]);
      }
    }
  }


}
